// import { SearchToolOrderInput } from '@bechtel/ht-types';
import { useLazyQuery, useMutation } from '@apollo/client';
import { ADD_DELETE_ROLE_PERMISSION, GET_ROLE_PERMISSIONS } from '@bechtel/ht-clients-common';
import {
  AddDeleteRolePermissionScopeResult,
  AddDeleteRolePermissionsInput,
  SearchRolePermissionScopeResult,
} from '@bechtel/ht-types';
import { useCallback } from 'react';

export const useRolePermissionScope = (refetchQueries = ['searchRolePermissionScopes']) => {
  const [addDeleteRolePermision, { data, loading, error }] = useMutation<
    { addUpdateResult: AddDeleteRolePermissionScopeResult },
    { addDeleteRolePermissionsInput: AddDeleteRolePermissionsInput }
  >(ADD_DELETE_ROLE_PERMISSION, {
    refetchQueries: refetchQueries,
  });

  const addDeleteRolePermission = useCallback(
    (
      addDeleteRolePermissionsInput: AddDeleteRolePermissionsInput,
      onComplete?: (data) => void,
      onError?: (err) => void
    ) => {
      addDeleteRolePermision({
        variables: {
          addDeleteRolePermissionsInput: addDeleteRolePermissionsInput,
        },
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data);
          }
        },
        onError: (err) => {
          if (onError) {
            onError(err);
          }
        },
      });
    },
    [addDeleteRolePermision]
  );

  return { addDeleteRolePermission, data, loading, error };
};
export const useGetRolePermissionList = () => {
  const [getRolePermissionListQuery, { data, loading, error, refetch, networkStatus, fetchMore }] = useLazyQuery<{
    searchRolePermissions: SearchRolePermissionScopeResult;
  }>(GET_ROLE_PERMISSIONS, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });
  const getRolePermissionList = useCallback(
    (onComplete?: (data) => void) => {
      getRolePermissionListQuery({
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data);
          }
        },
        fetchPolicy: 'network-only',
      });
    },
    [getRolePermissionListQuery]
  );

  return { getRolePermissionList, data, loading, error, refetch, networkStatus, fetchMore };
};
